import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: resolve => require(['../views/login.vue'], resolve),
    meta: {
      title: '登录'
    }
  }
]

export default new VueRouter({
  routes
})
